import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { parseSlotSelectionData } from "./parser"
const initialState = {
    isFetching: false,
    isFetched: false,
    data: null,
    error: null,
}

export const selfServeSlotSelectionSlice = createSlice({
    name: "selfServeSlotSelection",
    initialState: initialState,
    reducers: {
        clearSlotData: (state) => {
            state = initialState
            return state
        },
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchSlotSelectionData.fulfilled, (state, action) => {
            state.data = parseSlotSelectionData(action.payload?.bottom_sheets)
            state.isFetched = true
            state.isFetching = false
            state.error = false
        }),
            builder.addCase(fetchSlotSelectionData.pending, (state) => {
                state.isFetching = true
                state.isFetched = false
                state.error = null
                state.data = null
            }),
            builder.addCase(fetchSlotSelectionData.rejected, (state, action) => {
                state.isFetching = false
                state.isFetched = true
                state.data = null
                state.error = action.payload
            })
    },
})

/**
 * @description Fetch Slot Selector data for self serve (PPMC) flow
 */
export const fetchSlotSelectionData = createAsyncThunk(
    "selfServeSlotSelectionReducer/fetchData",
    async (_arg, { extra, rejectWithValue }) => {
        const { ppmcApi } = extra
        try {
            const res = await ppmcApi.get("v6/self-serve/slots")

            return Promise.resolve(res.data)
        } catch (error) {
            return rejectWithValue(error?.message || error?.error?.message || true)
        }
    }
)
export const { clearSlotData } = selfServeSlotSelectionSlice.actions

export const selfServeSlotSelectionReducer = selfServeSlotSelectionSlice.reducer
